/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const drawerPaperPropsStyles = {
  width: 'max(25%, 360px)',
  height: 'calc(100% - 60px)',
  mt: 15,
  borderTopLeftRadius: 16,
  borderBottomLeftRadius: 16,
  overflow: 'visible',
  px: 5,
  pt: 5,
  pb: 2,
  pointerEvents: 'auto',
};

export const historicalBackdropStyles = {
  backgroundColor: 'rgba(128, 128, 128, 0.4)',
  backdropFilter: 'grayscale(100%) blur(4px)',
  WebkitBackdropFilter: 'grayscale(100%) blur(4px)',
  pointerEvents: 'auto',
};

export const accordionStyles = {
  mb: 2,
  border: '1px solid',
  borderRadius: '12px !important',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
  transition: '0.3s ease-in-out',
  '&:hover': {
    boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.15)',
  },
  '&:before': {
    display: 'none',
  },
};
